module.exports = __webpack_public_path__ + "img/jiaot1.fdb5356b.png";